/* global axios */
import ApiClient from '../ApiClient';

// CRUD das entradas do playbook do Capitao (Central de Calibracao, admin).
// O backend espera/retorna o recurso embrulhado em { playbook_entry: {...} }.
// R6.4: com versao='rascunho', o CRUD inteiro passa a operar sobre a copia do sandbox,
// e o que esta no ar (o que o Bira responde agora) fica intocado.
class PlaybookEntriesAPI extends ApiClient {
  constructor() {
    super('fandata/playbook_entries', { accountScoped: true });
  }

  get(versao) {
    return axios.get(this.url, { params: versao ? { versao } : {} });
  }

  create(entry, versao) {
    return axios.post(this.url, { playbook_entry: entry, versao });
  }

  update(id, entry, versao) {
    return axios.patch(`${this.url}/${id}`, { playbook_entry: entry, versao });
  }

  delete(id, versao) {
    return axios.delete(`${this.url}/${id}`, {
      params: versao ? { versao } : {},
    });
  }
}

export default new PlaybookEntriesAPI();
